import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    createSuccess:
      'Your invoice has been created, you can edit its content before sending it.',
    createTitle: 'Invoice creation',
    ctaPrimary: 'Validate the invoice',
    delete: 'Delete',
    editTitle: 'Invoice edition',
    error:
      'Your invoice contains errors. Check the information in the incorrect fields.',
    help: 'Help',
    save: 'Save',
    saveSuccess: 'Your changes have been saved',
  },
  fr: {
    createSuccess:
      'Votre facture a été créée, vous pouvez modifier son contenu avant de l’envoyer.',
    createTitle: 'Création de la facture',
    ctaPrimary: 'Valider la facture',
    delete: 'Supprimer',
    editTitle: 'Édition de la facture',
    error:
      'Votre facture contient des erreurs. Vérifiez les informations des champs erronés.',
    help: 'Aide',
    save: 'Enregistrer',
    saveSuccess: 'Vos modifications ont été sauvegardées',
  },
} as const);

export default locales;
